/**
 * Calculate end time based on start time and duration in minutes
 * @param startTime - Time in HH:MM format (e.g., "15:00")
 * @param durationMinutes - Duration in minutes (e.g., 60)
 * @returns End time in HH:MM format (e.g., "16:00")
 */
export const calculateEndTime = (startTime: string, durationMinutes: number): string => {
  const [hours, minutes] = startTime.split(':').map(Number);
  const totalMinutes = hours * 60 + minutes + durationMinutes;
  const endHours = Math.floor(totalMinutes / 60) % 24;
  const endMinutes = totalMinutes % 60;
  return `${String(endHours).padStart(2, '0')}:${String(endMinutes).padStart(2, '0')}`;
};

/**
 * Format date to YYYY-MM-DD format
 * @param date - Date object or ISO string
 * @returns Formatted date string (e.g., "2026-02-16")
 */
export const formatAppointmentDate = (date: Date | string): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
